<template>
  <div class="page" style="margin-left: 200px">
    <el-card class="card" :body-style="{ padding: '20px 20px 0 20px' }">
      <div class="header">
        <span :class="showView == 1 ? 'showViewClass' : 'viewClass'" @click="showView = 1" >{{ $t('TankService.DataStatistics') }}</span>
        <div style="width: 2px;height: 16px;margin: 3px 8px; background-color: #9c9c9c;"></div>
        <span :class="showView == 2 ? 'showViewClass' : 'viewClass'" @click="showView = 2">{{ $t('TankService.OrderInquiry') }}</span>
        <div v-if="this.customerCode==='PT201905021782' || this.customerCode==='201808014924' || this.customerCode==='PT202403097081'" style="width: 2px;height: 16px;margin: 3px 8px; background-color: #9c9c9c;"></div>
        <span v-if="this.customerCode==='PT201905021782' || this.customerCode==='201808014924' || this.customerCode==='PT202403097081'" :class="showView == 3 ? 'showViewClass' : 'viewClass'" @click="showView = 3">{{ $t('TankService.CanTracking') }}</span>
      </div>
      <div class="mtf1" style="display: flex; column-gap: 8px; align-items: center">
        <span>{{ $t('TankService.BusinessType') + ' :' }}</span>
        <el-select
          v-model="jobType"
          class="elSelect"
          size="small"
          :popper-append-to-body="true"
        >
          <el-option
            v-for="(item, index) in selectList"
            :key="index"
            :value="item.value"
            :label="item.label"
          />
        </el-select>
        <div
          v-if="showView === 2"
          class="scription-center"
          @click="showScription()"
        >
          <i class="el-icon-collection" style="margin-right: 4px"></i
          >{{ $t('TankService.SubscriptionCenter') }}
        </div>
      </div>
    </el-card>
    <div v-if="showView === 1">
      <DataStatistics
        :job-type.sync="jobType"
        :customer-code.sync="customerCode"
        :customer-name.sync="customerName"
      />
    </div>
    <div v-if="showView === 2">
      <div v-if="jobType === 'TE'">
        <TEorderSearch
          :customer-code.sync="customerCode"
          :customer-name.sync="customerName"
        />
      </div>
      <div v-if="jobType === 'TD'">
        <TDorderSearch
          :customer-code.sync="customerCode"
          :customer-name.sync="customerName"
        />
      </div>
      <div v-if="jobType === 'TY'">
        <TYorderSearch
          :customer-code.sync="customerCode"
          :customer-name.sync="customerName"
        />
      </div>
    </div>
    <div v-if="showView === 3">
      <TankTracking
        :job-type.sync="jobType"
        :customer-code.sync="customerCode"
        :customer-name.sync="customerName"
      />
    </div>
    <ScriptCenter
      ref="scriptCenter"
      @success="$refs.SubscriptionSuccess.open()"
    />
    <SubscriptionSuccess ref="SubscriptionSuccess" />
  </div>
</template>
<script>
import DataStatistics from './modules/dataStatistics.vue'
import TDorderSearch from './modules/tdorderSearch.vue'
import TEorderSearch from './modules/teorderSearch.vue'
import TYorderSearch from './modules/tyorderSearch.vue'
import TankTracking from './modules/tankTracking.vue'
import { USER_INFO } from '@/store/mutation-types'
import ScriptCenter from '@/components/scriptCenter.vue'
import SubscriptionSuccess from '@/components/subscriptionSuccess.vue'
import i18n from '@/i18n/i18n'
export default {
  components: {
    DataStatistics,
    TDorderSearch,
    TEorderSearch,
    TYorderSearch,
    ScriptCenter,
    SubscriptionSuccess,
    TankTracking
  },
  data() {
    return {
      showView: 1,
      customerCode: '',
      customerName: '',
      /** 线路筛选 */
      jobType: 'TE',
      selectList: [
        { value: 'TE', label: i18n.t('TankService.Foreigntrade') },
        { value: 'TD', label: i18n.t('TankService.Domestictrade') },
        { value: 'TY', label: i18n.t('TankService.Yard') }
      ],
      lang: 'zh'
    }
  },
  computed: {
    userInfo() {
      return this.$ls.get(USER_INFO) || {}
    },
  },
  mounted() {
    this.lang = this.$ls.get('lang');
  },
  created() {
    this.customerCode = (this.$route.customerCode && this.$route.query.customerCode) ?? this.userInfo.CACode
    this.customerName = (this.$route.customerName && this.$route.query.customerName) ?? this.userInfo.CAName

    //  this.customerCode = '201808014924'
    //  this.customerName = '大金氟化工（中国）有限公司'
    // this.customerCode = '201808018582'
    // this.customerName = '万华化学（烟台）销售有限公司'
    // this.customerCode = '201808002685'
    // this.customerName = '德哈拓物流（上海）有限公司'
    // this.customerCode = '201808018585'
    // this.customerName = '万华化学集团股份有限公司'
  },
  methods: {
    showScription() {
      this.$refs.scriptCenter.open('GMS_' + this.jobType)
    }
  }
}
</script>
<style lang="scss" scoped>
.mtf1 {
  float: right;
  margin-top: -1px;
  border-top: #fff;
  .scription-center {
    border: 1px solid #53a2b6;
    color: #53a2b6;
    height: 30px;
    line-height: 18px;
    border-radius: 4px;
    padding: 4px 16px;
    cursor: pointer;
  }
}
.page >>> .el-card.is-always-shadow {
  box-shadow: initial !important;
}
.page {
  padding: 10px;
  background: #f0f6fb;
  min-width: 1200px;
}
.page .card .header {
  float: left;
  display: flex;
  line-height: 22px;
  font-weight: bold;
}
.page .card .header .viewClass {
  color: #9c9c9c;
  cursor: pointer;
}
.page .card .header .showViewClass {
  color: #59b9d3;
  cursor: pointer;
}
.elSelect {
  width: 150px;
  margin-left: 10px;
  margin-right: 20px;
  border-radius: 8px;
}
.header {
  font-size: 18px;
}
</style>
